/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import StorageKeys from 'constants/StorageKeys';
import { AuthState, AuthStatus } from './authState';

const sidFromLS = localStorage.getItem(StorageKeys.authSid);

const initialState: AuthState = sidFromLS
  ? {
      status: AuthStatus.LoggedIn,
      sid: sidFromLS,
    }
  : {
      status: AuthStatus.Guest,
    };

export const authSlice = createSlice({
  name: 'auth',
  initialState: initialState as AuthState,
  reducers: {
    logout: (state) => {
      state.status = AuthStatus.Guest;
    },
    login: (state, action: PayloadAction<AuthSID>) => {
      state.status = AuthStatus.LoggedIn;
      if (state.status === AuthStatus.LoggedIn) {
        state.sid = action.payload;
      }
    },
  },
});
